import {
  GET_FEATURES,
  GET_FEATURES_SUCCESS,
  GET_FEATURES_FAILURE,
} from "./actionTypes";

const initialState = {
  features: [],
  loading: false,
  error: "",
};

const brands = (state = initialState, action) => {
  switch (action.type) {
    case GET_FEATURES:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_FEATURES_SUCCESS:
      state = {
        ...state,
        loading: false,
        features: action.payload.features,
      };
      break;
    case GET_FEATURES_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default brands;
